export const legalEntities = {
  "legalEntity.russianFrmoOid": "Medical organization OID (FRMO)",
  "legalEntity.russianFrmoOidHint": "Optional Russian medical organization identifier in the Ministry of Health FRMO register. Required only when preparing an EGISZ document.",
  "legalEntity.russianRegionCode": "Russian address region (FNS code)",
  "legalEntity.russianOgrn": "Russian organization registration number (OGRN)",
  "legalEntity.title": "Legal identities",
  "legalEntity.subtitle": "Reusable legal identities owned by this clinic.",
  "legalEntity.create": "Add legal identity",
  "legalEntity.open": "Open {name}",
  "legalEntity.actions": "Actions",
  "legalEntity.legalName": "Exact legal name",
  "legalEntity.publicName": "Public name",
  "legalEntity.shortName": "Short name for the interface",
  "legalEntity.publicNameHint": "Optional. Used in the header and organization chooser; the full legal name is shown when empty. New printed documents and EGISZ use the full legal name.",
  "legalEntity.kind": "Kind",
  "legalEntity.organization": "Organization",
  "legalEntity.individual_business": "Individual business",
  "legalEntity.lifecycle": "Status",
  "legalEntity.active": "Active",
  "legalEntity.archived": "Archived",
  "legalEntity.current": "Current revision",
  "legalEntity.historyOption": "{revision} · in effect until {until} · {author}",
  "legalEntity.historyOptionUnattributed": "{revision} · in effect until {until}",
  "legalEntity.archive": "Archive",
  "legalEntity.restore": "Restore",
  "legalEntity.save": "Save",
  "legalEntity.saving": "Saving…",
  "legalEntity.loading": "Loading legal identities…",
  "legalEntity.empty": "No legal identities",
  "legalEntity.emptyDetail": "Add an organization or individual business to this clinic’s register.",
  "legalEntity.loadFailed": "Legal identities could not be loaded.",
  "legalEntity.forbidden": "You do not have permission to access legal identities.",
  "legalEntity.readOnly": "Read-only revision",
  "legalEntity.failed": "The change was not saved. Your draft is retained.",
  "legalEntity.invalid": "Check the fields and validity dates. The change was not saved.",
  "legalEntity.duplicate": "This tax identity is already registered in this clinic, possibly in the archive.",
  "legalEntity.conflict": "This identity changed. Load the latest revision and review it before saving your retained draft.",
  "legalEntity.lifecycleConflict": "The identity’s status no longer allows this action. Reload it to review the current status.",
  "legalEntity.reload": "Load latest revision",
  "legalEntity.latest": "Latest saved details",
  "legalEntity.unsaved": "Legal identity draft",
  "legalEntity.unsavedPublicName": "Legal identity public name",
  "legalEntity.comment": "Comment",
  "legalEntity.validFrom": "Valid from",
  "legalEntity.validTo": "Valid through",
  "legalEntity.taxNone": "No tax identifier",
  "legalEntity.recordedAt": "Recorded at"
} as const
